import ClickOutside from './ClickOutside'

export default {
  install: (app) => {
    app.directive('click-outside', ClickOutside)
  },
}
